export default "__VITE_ASSET__CfS8pTgE__"